import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AntdModule } from '@core/config/antd.module';
import { AppFormHeaderComponent } from '@components/layout/header/app-form-header.component';
import { AppBackToTopComponent } from '@components/widgets/back-to-top/app-back-to-top.component';

/**
 * Layout compartido de las pantallas de formulario.
 *
 * Un único "rail" es dueño del `padding-inline` (y del cap opcional de ancho);
 * el header y el contenido viven dentro de él, por lo que quedan alineados
 * por construcción (antes cada template lo cableaba a mano y divergía).
 * Por defecto el rail ocupa el 100% del ancho disponible (maxWidth='full').
 *
 * Slots de proyección:
 *  - default           -> contenido del form (secciones/nz-card/tabs/cms)
 *  - [formLayoutError] -> app-form-error, dentro de la zona del header
 *  - [formLayoutAside] -> columna lateral (solo con twoColumn)
 *  - [formLayoutFooter]-> barra de acciones/footer
 * Los modales/overlays se dejan como hermanos de <app-form-layout> en el host.
 */
@Component({
  standalone: true,
  selector: 'app-form-layout',
  imports: [AntdModule, AppFormHeaderComponent, AppBackToTopComponent],
  templateUrl: './app-form-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./app-form-layout.component.scss'],
})
export class FormLayoutComponent {
  @Input() form: any;
  @Input() showHeader = true;
  @Input() twoColumn = false;
  @Input() maxWidth: 'standard' | 'wide' | 'full' = 'full';
  @Input() padding: 'default' | 'flush' = 'default';
  @Input() showBackTop = true;
  @Output() goBackEvent = new EventEmitter<void>();
}
